import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';
import './FaqPage.css';

const SECTIONS = [
  { id: 'start',    label: '🚀 Ξεκινώντας' },
  { id: 'calendar', label: '📅 Ημερολόγιο' },
  { id: 'bookings', label: '📋 Κρατήσεις' },
  { id: 'clients',  label: '👥 Πελάτες' },
  { id: 'services', label: '✂️ Υπηρεσίες' },
  { id: 'staff',    label: '👤 Υπάλληλοι' },
  { id: 'stats',    label: '📊 Στατιστικά' },
  { id: 'settings', label: '⚙️ Ρυθμίσεις' },
];

export default function DocsPage() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('start');

  return (
    <div className="legal-root">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate('/')}>← Επιστροφή</button>
        <div className="legal-logo">✂ SalonBook</div>
      </header>

      <div className="docs-layout">
        {/* Sidebar */}
        <nav className="docs-sidebar">
          <div className="docs-sidebar-title">Οδηγός Χρήσης</div>
          {SECTIONS.map(s => (
            <button key={s.id}
              className={'docs-nav-item' + (activeSection === s.id ? ' active' : '')}
              onClick={() => setActiveSection(s.id)}>
              {s.label}
            </button>
          ))}
        </nav>

        {/* Content */}
        <div className="docs-content">

          {activeSection === 'start' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Ξεκινώντας με το SalonBook</h1>
              <p className="docs-lead">Καλώς ήρθατε! Αυτός ο οδηγός θα σας βοηθήσει να ξεκινήσετε γρήγορα.</p>

              <h2>1. Πρώτη σύνδεση</h2>
              <p>Μεταβείτε στο <strong>salonbook.gr</strong> και πατήστε "Σύνδεση". Εισάγετε τα στοιχεία πρόσβασης που σας δόθηκαν κατά την εγγραφή.</p>

              <h2>2. Ρυθμίστε το κομμωτήριό σας</h2>
              <p>Πηγαίνετε στις <strong>Ρυθμίσεις</strong> και συμπληρώστε:</p>
              <ul>
                <li>Όνομα κομμωτηρίου</li>
                <li>Ώρες λειτουργίας ανά ημέρα</li>
                <li>Τηλέφωνο και διεύθυνση</li>
              </ul>

              <h2>3. Προσθέστε υπηρεσίες</h2>
              <p>Πηγαίνετε στις <strong>Υπηρεσίες</strong> και δημιουργήστε τις υπηρεσίες που προσφέρετε (κόψιμο, βαφή κλπ) με διάρκεια και τιμή.</p>

              <h2>4. Προσθέστε υπαλλήλους</h2>
              <p>Πηγαίνετε στους <strong>Χρήστες</strong> και προσθέστε τους υπαλλήλους σας με email και κατάλληλα δικαιώματα.</p>

              <h2>5. Ξεκινήστε κρατήσεις!</h2>
              <p>Από το <strong>Ημερολόγιο</strong> πατήστε "+ Κράτηση" ή κλικάρετε σε οποιαδήποτε ώρα για να δημιουργήσετε την πρώτη σας κράτηση.</p>

              <div className="docs-tip">
                💡 <strong>Tip:</strong> Ξεκινήστε βάζοντας μερικές δοκιμαστικές κρατήσεις για να εξοικειωθείτε με το σύστημα.
              </div>
            </div>
          )}

          {activeSection === 'calendar' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Ημερολόγιο</h1>
              <p className="docs-lead">Το ημερολόγιο είναι η καρδιά του SalonBook.</p>

              <h2>Προβολές</h2>
              <ul>
                <li><strong>Πλέγμα (Grid):</strong> Εβδομαδιαία προβολή με ώρες. Ιδανικό για desktop.</li>
                <li><strong>Λίστα:</strong> Ημερήσια προβολή. Ιδανικό για mobile.</li>
              </ul>
              <p>Εναλλάσσετε προβολή με τα κουμπιά ☰ / ⊞ πάνω δεξιά.</p>

              <h2>Πλοήγηση</h2>
              <ul>
                <li>Βέλη ‹ › για εβδομάδα/ημέρα πίσω-μπρος</li>
                <li>Κλικ σε ημέρα (εβδομαδιαία προβολή) → μεταβαίνει στην ημερήσια</li>
                <li>Swipe αριστερά/δεξιά σε mobile για αλλαγή ημέρας</li>
              </ul>

              <h2>Δημιουργία κράτησης</h2>
              <ul>
                <li>Κλικ σε κενή ώρα στο πλέγμα</li>
                <li>Κουμπί "+ Κράτηση" πάνω δεξιά</li>
              </ul>

              <h2>Φίλτρα υπαλλήλων</h2>
              <p>Χρησιμοποιήστε τα pills με τα ονόματα υπαλλήλων για να φιλτράρετε και να δείτε μόνο τις κρατήσεις ενός υπαλλήλου.</p>

              <h2>Χρωματικός κώδικας</h2>
              <p>Κάθε υπάλληλος έχει το δικό του χρώμα. Οι κρατήσεις εμφανίζονται με το χρώμα του υπαλλήλου στον οποίο ανήκουν.</p>
            </div>
          )}

          {activeSection === 'bookings' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Κρατήσεις</h1>
              <p className="docs-lead">Διαχειριστείτε όλες τις κρατήσεις από μια κεντρική σελίδα.</p>

              <h2>Δημιουργία κράτησης</h2>
              <ol>
                <li>Πατήστε "+ Κράτηση"</li>
                <li>Γράψτε όνομα πελάτη (το σύστημα ψάχνει αυτόματα υπάρχοντες πελάτες)</li>
                <li>Συμπληρώστε τηλέφωνο (υποχρεωτικό για νέους πελάτες)</li>
                <li>Επιλέξτε υπάλληλο, υπηρεσία, ημερομηνία και ώρα</li>
                <li>Προαιρετικά: σημειώσεις, έκπτωση, φιλοδώρημα</li>
                <li>Αποθήκευση</li>
              </ol>

              <h2>Καταστάσεις κράτησης</h2>
              <ul>
                <li>🟡 <strong>Εκκρεμής:</strong> Νέα κράτηση που δεν έχει επιβεβαιωθεί</li>
                <li>🟢 <strong>Επιβεβαιωμένη:</strong> Ο πελάτης επιβεβαίωσε</li>
                <li>🔵 <strong>Ολοκληρώθηκε:</strong> Η υπηρεσία πραγματοποιήθηκε</li>
                <li>🔴 <strong>Ακυρώθηκε:</strong> Η κράτηση ακυρώθηκε</li>
                <li>🟣 <strong>Δεν ήρθε:</strong> No-show</li>
              </ul>

              <h2>Έκπτωση</h2>
              <p>Στο πεδίο "Τιμή / Έκπτωση" μπορείτε να βάλετε διαφορετική τιμή από την κανονική. Η έκπτωση εμφανίζεται με διακεκομμένη κανονική τιμή και κόκκινη νέα τιμή.</p>

              <div className="docs-tip">
                💡 <strong>Tip:</strong> Χρησιμοποιήστε τα φίλτρα "Σήμερα", "Αύριο", "Εβδομάδα" για γρήγορη επισκόπηση.
              </div>
            </div>
          )}

          {activeSection === 'clients' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Πελάτες</h1>
              <p className="docs-lead">Διατηρήστε πλήρες αρχείο για κάθε πελάτη σας.</p>

              <h2>Αυτόματη δημιουργία</h2>
              <p>Κάθε φορά που δημιουργείτε κράτηση με τηλέφωνο, ο πελάτης αποθηκεύεται αυτόματα στο πελατολόγιο.</p>

              <h2>Αναζήτηση πελατών</h2>
              <p>Κατά τη δημιουργία κράτησης, το σύστημα ψάχνει αυτόματα υπάρχοντες πελάτες καθώς πληκτρολογείτε όνομα ή τηλέφωνο.</p>

              <h2>Ιστορικό πελάτη</h2>
              <p>Από τη σελίδα Πελατών μπορείτε να δείτε όλες τις παλιές κρατήσεις κάθε πελάτη.</p>
            </div>
          )}

          {activeSection === 'services' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Υπηρεσίες</h1>
              <p className="docs-lead">Ορίστε τις υπηρεσίες που προσφέρει το κομμωτήριό σας.</p>

              <h2>Δημιουργία υπηρεσίας</h2>
              <ul>
                <li><strong>Όνομα:</strong> π.χ. "Κόψιμο", "Βαφή", "Χτένισμα"</li>
                <li><strong>Διάρκεια:</strong> σε λεπτά</li>
                <li><strong>Τιμή:</strong> σε ευρώ</li>
                <li><strong>Χρώμα:</strong> εμφανίζεται στο ημερολόγιο</li>
              </ul>

              <h2>Σειρά εμφάνισης</h2>
              <p>Οι υπηρεσίες εμφανίζονται στη φόρμα κράτησης με τη σειρά που τις έχετε δημιουργήσει. Η πρώτη υπηρεσία επιλέγεται αυτόματα.</p>

              <div className="docs-tip">
                💡 <strong>Tip:</strong> Βάλτε σωστές τιμές στις υπηρεσίες για να λειτουργούν σωστά τα στατιστικά εσόδων.
              </div>
            </div>
          )}

          {activeSection === 'staff' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Υπάλληλοι</h1>
              <p className="docs-lead">Προσθέστε υπαλλήλους και ορίστε τα δικαιώματά τους.</p>

              <h2>Επίπεδα δικαιωμάτων</h2>
              <div className="docs-roles">
                <div className="docs-role">
                  <div className="docs-role-icon">👤</div>
                  <div>
                    <h4>Βασικός υπάλληλος</h4>
                    <p>Πρόσβαση μόνο στο Ημερολόγιο</p>
                  </div>
                </div>
                <div className="docs-role">
                  <div className="docs-role-icon">📋</div>
                  <div>
                    <h4>Υπάλληλος κρατήσεων</h4>
                    <p>Ημερολόγιο + Κρατήσεις</p>
                  </div>
                </div>
                <div className="docs-role">
                  <div className="docs-role-icon">👥</div>
                  <div>
                    <h4>Υπάλληλος πελατών</h4>
                    <p>Ημερολόγιο + Κρατήσεις + Πελάτες</p>
                  </div>
                </div>
                <div className="docs-role">
                  <div className="docs-role-icon">👑</div>
                  <div>
                    <h4>Διαχειριστής</h4>
                    <p>Πρόσβαση σε όλα</p>
                  </div>
                </div>
              </div>

              <h2>Αλλαγή δικαιωμάτων</h2>
              <p>Στη σελίδα "Χρήστες" πατήστε "✏️ Δικαιώματα" δίπλα στον υπάλληλο και επιλέξτε νέο επίπεδο.</p>

              <h2>Απενεργοποίηση υπαλλήλου</h2>
              <p>Αν ένας υπάλληλος φύγει, μπορείτε να απενεργοποιήσετε τον λογαριασμό του χωρίς να χάσετε το ιστορικό κρατήσεών του.</p>
            </div>
          )}

          {activeSection === 'stats' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Στατιστικά</h1>
              <p className="docs-lead">Παρακολουθήστε την απόδοση του κομμωτηρίου σας.</p>

              <h2>Διαθέσιμα γραφήματα</h2>
              <ul>
                <li>📅 Κρατήσεις ανά ημέρα</li>
                <li>💶 Έσοδα ανά ημέρα</li>
                <li>✂️ Κατανομή ανά υπηρεσία</li>
                <li>👤 Απόδοση ανά υπάλληλο</li>
                <li>📆 Κρατήσεις ανά ημέρα εβδομάδας</li>
                <li>🕐 Κρατήσεις ανά ώρα</li>
                <li>📊 Κατάσταση κρατήσεων</li>
              </ul>

              <h2>Χρονικά εύρη</h2>
              <p>Επιλέξτε: 7 ημέρες, 30 ημέρες, τρέχων μήνας ή 3 μήνες.</p>

              <h2>Υπολογισμός εσόδων</h2>
              <p>Τα έσοδα υπολογίζονται αθροίζοντας την τιμή κάθε κράτησης (ή έκπτωση αν υπάρχει) συν φιλοδώρημα. Ακυρωμένες και no-show κρατήσεις εξαιρούνται.</p>
            </div>
          )}

          {activeSection === 'settings' && (
            <div className="docs-section">
              <div className="legal-badge">Οδηγός</div>
              <h1>Ρυθμίσεις</h1>
              <p className="docs-lead">Προσαρμόστε το SalonBook στις ανάγκες σας.</p>

              <h2>Στοιχεία επιχείρησης</h2>
              <ul>
                <li>Όνομα κομμωτηρίου</li>
                <li>Τηλέφωνο</li>
                <li>Διεύθυνση και πόλη</li>
              </ul>

              <h2>Ωράριο λειτουργίας</h2>
              <p>Ορίστε ώρες έναρξης και λήξης για κάθε ημέρα της εβδομάδας. Μπορείτε να κλείσετε συγκεκριμένες ημέρες (π.χ. Κυριακή).</p>

              <h2>Ωράριο στο ημερολόγιο</h2>
              <p>Το ημερολόγιο εμφανίζει μόνο τις ώρες λειτουργίας. Κλειστές ώρες εμφανίζονται γκριζαρισμένες.</p>

              <div className="docs-tip">
                💡 <strong>Tip:</strong> Ορίστε το ωράριο πριν αρχίσετε να βάζετε κρατήσεις για να έχετε σωστή εικόνα στο ημερολόγιο.
              </div>
            </div>
          )}

        </div>
      </div>

      <footer className="legal-footer">
        <span>© {new Date().getFullYear()} SalonBook. Όλα τα δικαιώματα διατηρούνται.</span>
        <div className="legal-footer-links">
          <a href="/privacy">Πολιτική Απορρήτου</a>
          <a href="/terms">Όροι Χρήσης</a>
          <a href="/gdpr">GDPR</a>
        </div>
      </footer>
    </div>
  );
}